import { SVLNewServiceStep1 } from "../screens/svl/newservicestep1/allactions"
import { SVLNewServiceStep2 } from "../screens/svl/newservicestep2/allactions"
import { SVLNewServiceStep3 } from "../screens/svl/newservicestep3/allactions"

export let screens = {
  SVLNewServiceStep1,
  SVLNewServiceStep2,
  SVLNewServiceStep3,
}
